export function replaceAgentMessage(messages, message, { streaming = true, status } = {}) {
  const last = messages[messages.length - 1];
  const value = {
    ...(last?.type === 'ai' && last.streaming ? last : {}),
    id: last?.type === 'ai' && last.streaming ? last.id : Date.now() + 1,
    type: 'ai',
    content: message.content,
    metadata: message.metadata || {},
    backendMessageId: message.id || null,
    streaming,
    status,
    timestamp: last?.type === 'ai' && last.streaming ? last.timestamp : Date.now()
  };
  return last?.type === 'ai' && last.streaming ? [...messages.slice(0, -1), value] : [...messages, value];
}

export function agentCompletionMessage(info = {}) {
  return (
    info.message || {
      id: info.final?.message_id,
      role: 'assistant',
      content: info.final?.message ?? info.lastText ?? '',
      metadata: {
        protocol_version: 2,
        follow_up_actions: info.final?.follow_up_actions || [],
        tool_calls: info.final?.tool_calls || [],
        reasoning_steps: info.final?.reasoning_steps || (Array.isArray(info.final?.reasoning) ? info.final.reasoning : []),
        reasoning_summary: info.final?.reasoning_text || ''
      }
    }
  );
}

export function finishAgentMessages(messages, info = {}) {
  const last = messages[messages.length - 1];
  if (info.status === 'cancelled') {
    return last?.streaming ? [...messages.slice(0, -1), { ...last, streaming: false, status: 'cancelled' }] : messages;
  }
  const message = agentCompletionMessage(info);
  return replaceAgentMessage(messages, message, { streaming: false, status: 'completed' });
}

export function failAgentMessages(messages, error) {
  const last = messages[messages.length - 1];
  if (last?.subtype === 'insufficient_credits') return messages;
  const text = error?.message || 'The connection was interrupted. Please retry.';
  if (last?.type === 'ai' && last.streaming) {
    return [...messages.slice(0, -1), { ...last, streaming: false, status: 'failed', content: last.content || text, error: text }];
  }
  return [...messages, { id: Date.now() + 2, type: 'ai', content: text, timestamp: Date.now(), status: 'failed' }];
}

export function upsertAgentToolMessage(messages, data) {
  const callId = data.metadata?.tool_call_id;
  const messageId = data.metadata?.message_id;
  const index = messages.findIndex(
    (message) =>
      message.role === 'tool' && ((callId && message.metadata?.tool_call_id === callId) || (messageId && message.id === messageId))
  );
  const existing = index >= 0 ? messages[index] : {};
  const value = {
    ...existing,
    ...(messageId ? { id: messageId } : {}),
    role: 'tool',
    content: '',
    created_at: existing.created_at || new Date().toISOString(),
    metadata: {
      ...(existing.metadata || {}),
      ...(data.metadata || {}),
      tool_name: data.tool_name,
      args: data.args || existing.metadata?.args,
      tool_result: data.result
    }
  };
  if (index < 0) return [...messages, value];
  return messages.map((message, item) => (item === index ? value : message));
}
